import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Firefox iOS: suppress "Script error" that appears on first input focus/click.
// User can still interact after closing; error is transient and harmless.
if (typeof window !== 'undefined' && /Firefox|FxiOS/i.test(navigator.userAgent)) {
  const origOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (message === 'Script error.' || (message === 'Script error' && !source)) {
      return true; // Suppress default handling
    }
    if (origOnError) return origOnError.apply(this, arguments);
    return false;
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
